import { Injectable } from "@angular/core";
import { BaseHttpService } from "./base.http.service";
import { Observable } from "rxjs";
import { IRateCardData } from "src/app/store/termDeposits/term-deposit.facade";
import { HttpClient } from "@angular/common/http";
import { AppConfig } from "src/app/app.config";
import { IEnvironmentConfig } from "src/app/models/environmentConfig";

@Injectable()
export class RateCardService extends BaseHttpService {


    constructor(private http: HttpClient, private appConfig: AppConfig) {
        super();
    }

    get envSettings(): IEnvironmentConfig {
        return this.appConfig.getEnvironmentConfig();
    }
    
    public getRateCards(portfolioId?: number) : Observable<IRateCardData[]> {

        let url = `${this.envSettings.webApiUrl}ratecard`;
        
        if(!!portfolioId){
            url = `${url}?portfolioId=${portfolioId}`;
        }

        return this.http.get<IRateCardData[]>(url, {
            observe: 'body',
            responseType: 'json',
            headers: this.getHttpHeaders(),
        });
    } 
    
    public getTermsAndConditionsLink(productLinkToken: string): string {
        return `${this.envSettings.webApiUrl}documents?token=${encodeURIComponent(productLinkToken)}`;
    }
}